import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=f6410386"
import script from "./AppTab.vue?vue&type=script&lang=js"
export * from "./AppTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports